import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { DialogFrameModule } from "src/app/common/components/dialog-frame/dialog-frame.module";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";

@Component({
  selector: "tpm-leave-action-dialog",
  templateUrl: "leave-action-dialog.component.html",
  styleUrls: ["leave-action-dialog.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, DialogFrameModule, EneButtonModule]
})
export class LeaveActionDialogDialogComponent {
  public readonly dialogRef = inject(MatDialogRef<LeaveActionDialogDialogComponent>);
}
